const Contact = function () {
    $('.form-wrap__btn').on('click', function () {
        $('.contact-form-popup').addClass('show');
        const scrollY = window.scrollY + "px";
        document.body.style.top = `-${scrollY}`;
        setTimeout(() => {
            document.body.style.position = 'fixed';
        }, 600);
    });

    $('.contact-form-close').on('click', function () {
        $('.contact-form-popup').removeClass('show');
        const scrollY = document.body.style.top;
        document.body.style.position = '';
        document.body.style.top = '';
        document.documentElement.style = "scroll-behavior: auto";
        window.scrollTo(0, parseInt(scrollY || '0') * -1);
        window.addEventListener('scroll', () => {
            document.documentElement.style.setProperty('--scroll-y', `${window.scrollY}px`);
        });
    });
}

export default Contact;